export enum HTTPMethod {
  CONNECT = 'CONNECT',
  DELETE = 'DELETE',
  GET = 'GET',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
  TRACE = 'TRACE',
}

// Generic Response interface.
export interface Response {
  status: 'ok' | 'error'
  p: number
  total_count: number
  size: number
  offset: number
}

export type APIResponse<Data = {}> = Response & { data: Data }
